import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { P as PbRow } from './PbRow-9686de95.js';
import { P as PbContainer } from './PbContainer-af335ddc.js';
import { WidthTypeEnum } from '@teko-builder/types/pb';

const PbSection = React.forwardRef((props, ref) => {
    const { children, commonStyle, verticalAlignment, widthType, row, gutter } = props, other = __rest(props, ["children", "commonStyle", "verticalAlignment", "widthType", "row", "gutter"]);
    const { maxWidth } = commonStyle;
    let rowStyle = row === null || row === void 0 ? void 0 : row.commonStyle;
    rowStyle = Object.assign({ height: '100%' }, rowStyle);
    if (rowStyle === null || rowStyle === void 0 ? void 0 : rowStyle.maxWidth) {
        rowStyle = Object.assign({ marginLeft: 'auto !important', marginRight: 'auto !important' }, rowStyle);
    }
    return (jsx(PbContainer, Object.assign({ maxWidth: maxWidth, fluid: widthType === WidthTypeEnum.full, ref: ref, commonStyle: commonStyle }, other, { children: jsx(PbRow, Object.assign({ commonStyle: rowStyle, verticalAlignment: verticalAlignment, gutter: gutter }, { children: children })) })));
});
PbSection.displayName = 'Section';

export { PbSection as P };
